import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { checkoutStepDefinition } from "../CheckoutPage/CheckoutStartup";
import { searchFlowStepDefinition } from "../Common/Search/SearchStartup";
import { selectOfferStepDefinition } from "../TrainOfferPage/SelectOfferFlow/SelectOfferStartupFlow";
import { ticketOptionMainStepDefinition } from "../TrainOfferPage/TicketOptionFlow/TicketOptionStartupFlow";
import { fmlmViewInitStepDeclaration } from "./Steps/FmlmViewInitStep";
import { fmlmViewInformationStepDefination } from "./Steps/FmlmViewInformationStepDefination";
import { FmlmViewTransition } from "./Transition/FmlmViewTransition";
import { FmlmViewTicketOptionTransition } from "./Transition/FmlmViewTicketOptionTransition";

export const FmlmViewStartupFlow = new FlowDefinition("FmlmViewFlow");

FmlmViewStartupFlow.addStep(fmlmViewInitStepDeclaration);
FmlmViewStartupFlow.addStep(fmlmViewInformationStepDefination);
FmlmViewStartupFlow.addStep(searchFlowStepDefinition);
FmlmViewStartupFlow.addStep(selectOfferStepDefinition);
FmlmViewStartupFlow.addStep(ticketOptionMainStepDefinition);
FmlmViewStartupFlow.addStep(checkoutStepDefinition);

FmlmViewStartupFlow.setStartStep("FmlmViewInit_Step");

FmlmViewStartupFlow.addLink("FmlmViewInit_Step", "FmlmViewInformation_Step");
FmlmViewStartupFlow.addLink("FmlmViewInit_Step", "SelectOfferFlow");
FmlmViewStartupFlow.addLink("FmlmViewInit_Step", "TicketOptionFlow");
FmlmViewStartupFlow.addLink("TicketOptionFlow", "SelectOfferFlow");
FmlmViewStartupFlow.addLink("TicketOptionFlow", "TicketOptionFlow");

FmlmViewStartupFlow.addLink("FmlmViewInformation_Step", "SearchFlow");
FmlmViewStartupFlow.addLink("SearchFlow", "FmlmViewInit_Step");

FmlmViewStartupFlow.addLink("TicketOptionFlow", "CheckoutFlow");

FmlmViewStartupFlow.addTransition(FmlmViewTransition, "FmlmViewInit_Step");
FmlmViewStartupFlow.addTransition(FmlmViewTicketOptionTransition, "TicketOptionFlow");

export const FmlmViewStartupFlowDefinition = new StepDefinition({
  stepName: "FmlmViewFlow",
  stepFlow: FmlmViewStartupFlow,
  contextIsolation: false,
});
